var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"grey"},[_c('div',{staticClass:"d-flex px-5 py-2"},[_c('div',{staticClass:"text-h5"},[_vm._v(" Selected "+_vm._s(_vm.GET_fireSelected.users.length)+" of "+_vm._s(_vm.GET_fireSelected.total)+" ")])]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }